import type { FC } from 'react';
import { Navigate, Route, useLocation } from 'react-router';
import { useOptionalCapacityManagementRoot } from 'src/apis/capacity-management/use-capacity-management-root';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RoleGateway } from 'src/components/role-gateway';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { ReportingUploadsDraftedDetail } from 'src/pages/transport/products/drafted/detail';
import { ReportingUploadsDraftedOverview } from 'src/pages/transport/products/drafted/overview';
import { ReportingUploadsUploadedDetail } from 'src/pages/transport/products/uploaded/detail';
import { ReportingUploadsUploadedOverview } from 'src/pages/transport/products/uploaded/overview';

export const TransportProducts: FC = () => {
  const { search } = useLocation();

  const capacityManagementRoot = useOptionalCapacityManagementRoot();

  if (!capacityManagementRoot.loaded) {
    return <PageSpinner />;
  }

  return (
    <RootRoutes>
      <Route
        path="/transport/products/uploaded"
        element={
          // RoleGateway is needed, because "/rest/uploads/report"
          // doesn't handle 401 and 403, but returns 500
          <RoleGateway allowed={['TSO']}>
            <ReportingUploadsUploadedOverview
              capacityManagementRoot={capacityManagementRoot}
            />
          </RoleGateway>
        }
      />

      <Route
        path="/transport/products"
        element={
          <Navigate
            replace
            to={{ pathname: '/transport/products/uploaded', search }}
          />
        }
      />

      <Route
        path="/transport/products/uploaded/:rawDataId"
        element={
          <ReportingUploadsUploadedDetail
            capacityManagementRoot={capacityManagementRoot}
          />
        }
      />
      <Route
        path="/transport/products/drafted"
        element={
          <ReportingUploadsDraftedOverview
            capacityManagementRoot={capacityManagementRoot}
          />
        }
      />

      <Route
        path="/transport/products/drafted/:draftedProductId"
        element={
          <ReportingUploadsDraftedDetail
            capacityManagementRoot={capacityManagementRoot}
          />
        }
      />

      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
